import initialState from '../initialState';
import * as types from './actionTypes.projects';

let initialStateObj = {
    projects: initialState.projects,
    projectsStats: initialState.projectsStats,
    projectsLocationStats: initialState.projectsLocationStats,
    projectsAnalyticIntents: initialState.projectsAnalyticIntents,
    projectsUsersAnalytics: initialState.projectsUsersAnalytics,
    projectsAnalyticPatterns: initialState.projectsAnalyticPatterns,
    projectsAnalyticPatternFlows: initialState.projectsAnalyticPatternFlows,
    hasProjectsData: initialState.hasProjectsData,
    currentProject: initialState.currentProject,
    isProjectResetting: initialState.isProjectResetting,
    isProjectOptionsSaving: initialState.isProjectOptionsSaving,
    isProjectCreating: initialState.isProjectCreating,
    isProjectDeleting: initialState.isProjectDeleting,
    connectionDetails: initialState.connectionDetails,
};

export default function ProjectsReducer(state = initialStateObj, action) {
    let isTheSameProject;

    switch (action.type) {

        case types.GET_PROJECTS_REQ:
            return {
                ...state,
            };

        case types.GET_PROJECTS_OK:
            return {
                ...state,
                ...{ projects: action.projects },
                ...{ hasProjectsData: true }
            };

        case types.RECONNECT_PROJECT_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        isProjectConnected: false,
                    }
                }
            };

        case types.RECONNECT_PROJECT_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        isProjectConnected: true,
                    }
                }
            };

        case types.ADD_PROJECT_REQ:
        case types.ADD_PROJECT_BY_TEMPLATE_REQ:
            return {
                ...state,
                isProjectCreating: true,
            };

        case types.ADD_PROJECT_OK:
        case types.ADD_PROJECT_ERR:
        case types.ADD_PROJECT_BY_TEMPLATE_ERR:
            return {
                ...state,
                isProjectCreating: false,
            };

        case types.DELETE_PROJECT_REQ:
            return {
                ...state,
                isProjectDeleting: true,
            };

        case types.DELETE_PROJECT_OK:
        case types.DELETE_PROJECT_ERR:
            return {
                ...state,
                isProjectDeleting: false,
            };

        case types.ADD_PROJECT_BY_TEMPLATE_OK:
            return {
                ...state,
                isProjectCreating: false,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ tryMessage: action.project.tryMessage },
                    }
                }
            };

        case types.GET_PROJECT_REQ:
            isTheSameProject = action.projectId === state.currentProject.projectId;
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ tryMessage: isTheSameProject ? state.tryMessage : null },
                    }
                }
            };

        case types.GET_PROJECT_OK:
            isTheSameProject = action.project.projectId === state.currentProject.projectId;
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{
                            ...action.project,
                            ...{ stageTagId: action.keepSelectedStageTag ? state.currentProject.stageTagId : action.project.stageTagId }
                        },
                        ...{ reloadProjectTs: state.currentProject.reloadProjectTs },
                        ...{ savedOptions: state.currentProject.savedOptions },
                    }
                }
            };

        case types.GET_PROJECT_INFO_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{
                            ...action.project,
                        },
                    }
                }
            };

        case types.GET_SCRIPTS_IN_PROCESS:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ scriptsLoading: true },
                    }
                }
            };

        case types.GET_SCRIPTS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        updateTs: Date.now(),
                        ...{ scripts: [...action.scripts] },
                        ...{ hasScriptsData: true },
                        ...{ scriptsLoading: false },
                        ...{ reloadProjectTs: state.currentProject.reloadProjectTs }
                    }
                }
            };

        case types.CREATE_SCRIPT_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ addingScriptsIsInprocess: true },
                    }
                }
            };

        case types.CREATE_SCRIPT_OK:
        case types.CREATE_SCRIPT_ERR:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ addingScriptsIsInprocess: false },
                    }
                }
            };

        case types.SET_UP_PROJECT_TAG_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ scriptsHash: null },
                    }
                }
            };

        case types.ACTUAL_STATUS_FOR_SCRIPTS_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ scriptsAreActual: null },
                    }
                }
            };

        case types.ACTUAL_STATUS_FOR_SCRIPTS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{
                            scriptsAreActual: true,
                            scriptsHash: action.hash
                        },
                    }
                }
            };

        case types.ACTUAL_STATUS_FOR_SCRIPTS_ERR:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{
                            scriptsAreActual: false,
                            scriptsHash: action.hash
                        },
                    }
                }
            };


        case types.UPDATE_SCRIPT_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                    }
                }
            };

        case types.IMPORT_FILES_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        isImportingScriptsInProgress: true,
                    }
                }
            };

        case types.IMPORT_FILES_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        isImportingScriptsInProgress: false,
                        importConflictScripts: [],
                    }
                }
            };

        case types.IMPORT_FILES_RESET:
            return {
                ...state,
                ...{
                    currentProject: {
                        importConflictScripts: [],
                    }
                }
            };

        case types.IMPORT_FILES_ERR:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        importConflictScripts: action.importConflictScripts,
                        isImportingScriptsInProgress: false,
                    }
                }
            };

        case types.RENAME_PROJECT_TAG_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ tags: action.tags }
                    }
                }
            };

        case types.SET_SAVING_STATUS_FOR_SCRIPTS_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ scripts: (action.scripts ? action.scripts : state.currentProject.scripts) },
                        isScriptSaving: true,
                    }
                }
            };

        case types.DISCONNECT_PROJECT_REQ:
        case types.SET_SAVING_STATUS_FOR_SCRIPTS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        isScriptSaving: false,
                    }
                }
            };

        case types.SET_RELOAD_FLAG_IN_PROJECT:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        reloadProjectTs: Date.now()
                    }
                }
            };

        case types.MAKE_SCRIPTS_EDITABLE_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                    }
                }
            };

        case types.CHANGE_TAG_ID_IN_PROJECT:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        scriptsLoading: true,
                        hasScriptsData: false,
                        ...{ [action.environment + 'TagId']: action.tagId }
                    }
                }
            };

        case types.SCRIPT_WAS_UPDATED_SHOW_STATUS:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ showSavedStatus: true }
                    }
                }
            };

        case types.SCRIPT_WAS_UPDATED_HIDE_STATUS:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ showSavedStatus: false }
                    }
                }
            };

        case types.RELOAD_PROJECT_REQ:
        case types.MODEL_UPDATED_ERR:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        isModelActual: false
                    }
                }
            };

        case types.RELOAD_PROJECT_OK:
        case types.MODEL_UPDATED_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        reloadProjectTs: null,
                        isModelActual: true
                    }
                }
            };


        case types.RESET_PROJECT_REQ:
            return {
                ...state,
                ...{ isProjectResetting: true },
                ...{
                    currentProject: {
                        ...state.currentProject,
                        authData: null,
                        visualStates: [],
                        visualState: {},
                    }
                }
            };

        case types.CLEAR_CHAT_AND_DIALOG_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        authData: null,
                        visualStates: [],
                        visualState: {},
                    }
                }
            };

        case types.RESET_PROJECT_OK:
            return {
                ...state,
                ...{ isProjectResetting: false },
            };

        case types.RESET_PROJECT_ON_UI_REQ:
            return {
                ...state,
                ...{
                    currentProject: { ...initialState.currentProject },
                }
            };

        case types.SET_PROJECT_OPTIONS_REQ:
            return {
                ...state,
                ...{ isProjectOptionsSaving: true },
            };

        case types.SET_PROJECT_OPTIONS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...(action.propName && action.options ? { [action.propName]: action.options } : {})
                    },
                    ...{ isProjectOptionsSaving: false },
                }
            };

        case types.GET_PROJECT_STATISTICS_BY_RANGE_OK:
            return {
                ...state,
                ...{
                    projectsStats: {
                        ...state.projectsStats, ...{
                            [action.projectId]: action.stats
                        }
                    }
                },
            };

        case types.GET_PROJECT_STATISTICS_MIN_MAX_DATES_OK:
            return {
                ...state,
                ...{
                    projectsLocationStats: {
                        ...state.projectsLocationStats, ...{
                            [action.projectId]: { minMaxTs: action.minMaxTs, stats: null }
                        }
                    }
                },
            };

        case types.GET_PROJECT_LOCATION_STATISTICS_BY_DATES_OK:
            return {
                ...state,
                ...{
                    projectsLocationStats: {
                        ...state.projectsLocationStats, ...{
                            [action.projectId]: {
                                ...state.projectsLocationStats[action.projectId],
                                stats: action.stats || [],
                                userCount: action.userCount || null
                            }
                        }
                    }
                },
            };

        case types.GET_ANALYTICS_INTENTS_OK:
            return {
                ...state,
                ...{
                    projectsAnalyticIntents: {
                        ...state.projectsAnalyticIntents, ...{
                            [action.projectId]: [
                                ...action.intents
                            ]
                        }
                    }
                },
            };



        case types.GET_PATTERN_STATISTICS_BY_DATES_OK:
            return {
                ...state,
                ...{
                    projectsAnalyticPatterns: {
                        ...state.projectsAnalyticPatterns, ...{
                            [action.projectId]: {
                                patterns: [...action.patterns],
                            }
                        }
                    }
                },
            };

        case types.GET_TEST_CONVERSATIONS_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                    }
                }
            };

        case types.GET_TEST_CONVERSATIONS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        conversations: action.conversations,
                    }
                }
            };

        case types.IMPORT_TEST_CONVERSATIONS_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        isImportingOfTestCasesInProgress: true,
                    }
                }
            };

        case types.IMPORT_TEST_CONVERSATIONS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        isImportingOfTestCasesInProgress: false,
                    }
                }
            };

        case types.GET_BTN_OPTIONS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ savedOptions: [...action.savedOptions] }
                    }
                }
            };

        case types.EXPORT_LOGS_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ exportingLogs: true }
                    }
                }
            };

        case types.EXPORT_LOGS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ exportingLogs: false }
                    }
                }
            };

        case types.EXPORT_DIALOGS_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ exportingDialogs: true }
                    }
                }
            };

        case types.EXPORT_DIALOGS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ exportingDialogs: false }
                    }
                }
            };

        case types.DISCARD_SCRIPT_CHANGES_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ discardScriptsChangesTs: action.discardScriptsChangesTs }
                    }
                }
            };

        case types.UPDATE_PROJECT_AFTER_MERGE_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ updateTsAfterMerge: Date.now() }
                    }
                }
            };

        case types.UPDATE_PROJECT_AFTER_CICD_SYNC_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ updateTsAfterCiCdSync: Date.now() }
                    }
                }
            };

        case types.SAVE_VISUAL_STATE_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        visualStates: action.add === false ?
                            [...state.currentProject.visualStates] :
                            [...state.currentProject.visualStates, action.visualState],
                        visualState: action.visualState,
                        selectedVisualStateTs: action.selectedVisualStateTs,
                    }
                }
            };

        case types.SHOW_VISUAL_STATE_PANEL_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ visualStatePanelOpened: true }
                    }
                }
            };

        case types.HIDE_VISUAL_STATE_PANEL_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ visualStatePanelOpened: false },
                        ...{ selectedVisualStateTs: null }
                    }
                }
            };

        case types.SELECT_VISUAL_STATE_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ selectedVisualStateTs: action.visualStateTs }
                    }
                }
            };

        case types.SHOW_AUTH_DATA_PANEL_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        authDataPanelOpened: true
                    }
                }
            };
        case types.HIDE_AUTH_DATA_PANEL_REQ:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        authDataPanelOpened: false
                    }
                }
            };

        case types.GET_ACTIVE_PATTERNS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{
                            activePatterns: action.data,
                            activePatternsUpdateTs: Date.now()
                        }
                    }
                }
            };

        case types.SAVE_AUTH_DATA_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        authData: action.authData,
                    }
                }
            };

        // todo: consider refactoring for this part
        case types.UPDATE_PROJECT_CONNECT_DETAILS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ connectDetails: action.connectDetails },
                    }
                }
            };

        case types.UPDATE_STUDIO_CONNECT_DETAILS_OK:
            return {
                ...state,
                connectionDetails: action.connectionDetails
            };

        case types.GET_COHORTS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        hasCohortsData: true,
                        ...{ cohorts: action.cohorts },
                    }
                }
            };

        case types.GET_DEFAULT_WAKEWORD_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ defaultWakeWord: action.defaultWakeWord },
                    }
                }
            };

        case types.GET_DEFAULT_WAKEWORD_OPTIONS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ defaultWakeWordOptions: action.defaultWakeWordOptions },
                    }
                }
            };

        case types.GET_WAKEWORDS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        ...{ wakeWords: action.wakeWords },
                    }
                }
            };

        case types.SET_PROJECT_DECRIPTION_ERROR_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        projectDecriptionError: action.projectDecriptionError,
                    }
                }
            };

        case types.MANAGE_RUNTIME_ERRORS_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        hasRuntimeErrors: action.hasErrors,
                    }
                }
            };

        case types.GET_TRANSFORM_INFO_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        transformFiles: action.transformFiles,
                    }
                }
            };

        case types.SET_SCRIPTS_GRAPH_CACHE_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        scriptsGraphCache: {
                            [action.hash]: {
                                ...state.currentProject.scriptsGraphCache[action.hash],
                                [action.scriptId]: {
                                    dot: action.graph,
                                    title: action.title,
                                    val: action.val,
                                    svg: action.svg,
                                    engine: action.engine,
                                }
                            }
                        }
                    }
                }
            };

        case types.RESET_SCRIPTS_GRAPH_CACHE_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        scriptsGraphCache: {}
                    }
                }
            };

        case types.OPEN_LARGE_SCRIPT_OK:
            return {
                ...state,
                ...{
                    currentProject: {
                        ...state.currentProject,
                        openedLargeFiles: {
                            ...state.openedLargeFiles,
                            ...{
                                [action.scriptId]: true
                            }
                        }
                    }
                }
            };

        default:
            return state;
    }
}
